import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-notfound',
  template: '404',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotfoundComponent {
}
